import { ChangeDetectionStrategy, Component, Input, OnDestroy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO, SelectDeeplinkDO } from '../../../../../../system/system-dtos';

@Component({
  selector: 'app-table-cell-deeplink',
  templateUrl: './deeplink-table-cell.component.html',
  standalone: false,
})
export class DeeplinkTableCellComponent extends DataTypeComponent implements OnDestroy {
  @Input() formGroup: UntypedFormGroup;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() data: any;

  @Input() editMode: boolean;

  deeplink: SelectDeeplinkDO;

  ngOnDestroy() {}
}
